import { render } from "./SystemEmailMassages.vue?vue&type=template&id=460443bb&scoped=true"
import script from "./SystemEmailMassages.vue?vue&type=script&lang=js"
export * from "./SystemEmailMassages.vue?vue&type=script&lang=js"

import "./SystemEmailMassages.vue?vue&type=style&index=0&id=460443bb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460443bb"]])

export default __exports__